import accvoucher from './accvoucher.vue';
const voucher = {
    install: (Vue) => {
        Vue.component('accvoucher', accvoucher);
    }
};
export default voucher;